import { NextPage } from 'next'
import styles from '../_artistPage.module.scss'
import { staticPath, staticProps } from '../../../../utils/createApolloClient'
import dynamic from 'next/dynamic'
import { ARTISTS_LIST_QUERY } from '../../../../gql/queries/artists_list_query'
import { ARTIST_DETAILS_QUERY } from '../../../../gql/queries/artist_details_query'
import ArtistLayout from '../components/ArtistLayout'
import { Artist } from '../../../../__generated__/graphql'

const AlbumComponent = dynamic(
  () => import('../../../../components/AlbumComponent')
)

const AritstAlbumsPage: NextPage<{ artist: Artist }> = ({ artist }) => {
  if (!artist) return <></>

  return (
    <ArtistLayout artist={artist}>
      <div
        className={`${styles.panelContainer} ${styles.tableView} has-margins`}
      >
        {artist.albums.map((album) => (
          <AlbumComponent key={album.id} album={album} />
        ))}
      </div>
    </ArtistLayout>
  )
}

export const getStaticPaths = staticPath({
  additionalPaths: async ({ client }) => {
    const { data } = await client.query({
      query: ARTISTS_LIST_QUERY
    })

    const paths = data.artists.map((artist) => ({
      params: { id: artist.id.toString() }
    }))

    return {
      paths,
      fallback: true
    }
  }
})

export const getStaticProps = staticProps({
  additionalProps: async ({ client, ctx }) => {
    const {
      data: { artist }
    } = await client.query({
      query: ARTIST_DETAILS_QUERY,
      variables: { id: Number(ctx.params.id) }
    })

    return {
      artist
    }
  }
})

export default AritstAlbumsPage
